export const PAGE_CONFIG = {
  "title": "Daily-excl.smurf",
  "titleCN": "日报-去小号",
  "subTitle": "",
  "subTitleCN": "",
  "path": "/overview/xh-daily",
  "defaultTab": "overall",
  "tabList": [
    {
      "id": "overall",
      "tabName": "Overall",
      "tabNameCN": "总览",
      "isHaveNotification": true,
      "notificationPath": "/overview/xh-daily",
      "path": "/overview/xh-daily",
      "tabIcon": "",
      "logConfig": {
        "pageId": "203501",
        "pageName": "overviewDailyXh",
        "extInfo": "overviewDailyXh",
        "pagePath": "/overview/xh-daily"
      },
      "filters": [
        {
          "name": "DailyXhFilterCo",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "/overview/xh-daily",
          "componentList": [
            {
              "name": "KeyMetricTitle",
              "className": "",
              "type": "view",
              "style": {},
              "props": {}
            },
            {
              "name": "MobileKeyMetricsCo",
              "className": "dbd-mobile-card dbd-daily-card",
              "type": "view",
              "style": {},
              "props": {
                "config": {
                  "api": "/api/v1/dashboard/overview_daily/xh/key_performance_metrics",
                  "trendApi": "/api/v1/dashboard/overview_daily/xh/metrics_trend",
                  "isMoblie": true,
                  "isDark": true,
                  "haveJump": true,
                  "mainMetricsList": [
                    "DAU",
                    "Revenue",
                    "New",
                    "D2(T-1)",
                    "ARPU",
                    "Payer%",
                    "dau",
                    "revenue",
                    "new",
                    "d2",
                    "arpu",
                    "payer_ratio"
                  ],
                  "metricsList": [
                    "dau",
                    "revenue",
                    "new",
                    "d2",
                    "arpu",
                    "payer_ratio"
                  ]
                }
              },
              "children": [
                {
                  "name": "CommonRow",
                  "className": "",
                  "type": "layout",
                  "style": {},
                  "props": {},
                  "children": [
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "MetricCard",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "jumpUrl": "/engagement/active",
                              "componentMetrics": [
                                {
                                  "metricKey": "DAU",
                                  "trendKey": "dau",
                                  "enName": "DAU",
                                  "cnName": "日活跃",
                                  "rangeEnName": "Avg.DAU",
                                  "rangeCnName": "日平均活跃",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "type": "int",
                                  "decimal": 0,
                                  "icon": "user-u",
                                  "position": ""
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "MetricCard",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "jumpUrl": "/monetization/revenue",
                              "componentMetrics": [
                                {
                                  "metricKey": "Revenue",
                                  "trendKey": "revenue",
                                  "enName": "Revenue($)",
                                  "cnName": "付费金额($)",
                                  "rangeEnName": "Revenue($)",
                                  "rangeCnName": "付费金额($)",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "type": "decimals",
                                  "decimal": 2,
                                  "icon": "dollar",
                                  "position": ""
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "MetricCard",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "jumpUrl": "/engagement/register",
                              "componentMetrics": [
                                {
                                  "metricKey": "New",
                                  "trendKey": "new",
                                  "enName": "New",
                                  "cnName": "新进用户",
                                  "rangeEnName": "New",
                                  "rangeCnName": "新进用户",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "type": "int",
                                  "decimal": 0,
                                  "icon": "user-plus",
                                  "position": ""
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "CommonRow",
                  "className": "",
                  "type": "layout",
                  "style": {},
                  "props": {},
                  "children": [
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "MetricCard",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "jumpUrl": "/retention/index",
                              "componentMetrics": [
                                {
                                  "metricKey": "D2(T-1)",
                                  "trendKey": "d2",
                                  "enName": "D2(T-1)",
                                  "cnName": "次留(T-1)",
                                  "rangeEnName": "D2(T-1)",
                                  "rangeCnName": "次留(T-1)",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "type": "percent",
                                  "decimal": 2,
                                  "icon": "user-success",
                                  "position": ""
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "MetricCard",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "jumpUrl": "/monetization/revenue",
                              "componentMetrics": [
                                {
                                  "metricKey": "ARPU",
                                  "trendKey": "arpu",
                                  "enName": "ARPU($)",
                                  "cnName": "活跃ARPU($)",
                                  "rangeEnName": "ARPU($)",
                                  "rangeCnName": "活跃ARPU($)",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "type": "decimals",
                                  "decimal": 2,
                                  "icon": "user-dollar",
                                  "position": ""
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 8
                      },
                      "children": [
                        {
                          "name": "MetricCard",
                          "className": "",
                          "style": {},
                          "type": "view",
                          "props": {
                            "config": {
                              "jumpUrl": "/monetization/revenue",
                              "componentMetrics": [
                                {
                                  "metricKey": "Payer%",
                                  "trendKey": "payer_ratio",
                                  "enName": "Payer%",
                                  "cnName": "付费渗透率",
                                  "rangeEnName": "Payer%",
                                  "rangeCnName": "付费渗透率",
                                  "preUnit": "",
                                  "endUnit": "",
                                  "type": "percent",
                                  "decimal": 2,
                                  "icon": "pie-chart-icon",
                                  "position": ""
                                }
                              ]
                            }
                          },
                          "children": []
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "name": "EventService",
              "className": "",
              "type": "view",
              "style": {
                "marginTop": "10px"
              },
              "props": {},
              "children": [
                {
                  "name": "CommonRow",
                  "className": "",
                  "type": "layout",
                  "style": {},
                  "props": {},
                  "children": [
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "OverviewMetricsTrendCo",
                          "className": "",
                          "type": "view",
                          "style": {},
                          "props": {
                            "config": {
                              "renderIndex": 0,
                              "isMoblie": true,
                              "api": {
                                "metricsApi": "/api/v1/dashboard/overview_daily/xh/metrics_trend",
                                "dimensionApi": "/api/v1/dashboard/overview_daily/xh/dimension/metrics_trend"
                              },
                              "componentMetrics": [
                                {
                                  "enName": "DAU",
                                  "cnName": "日活跃",
                                  "metricKey": "dau",
                                  "type": "int",
                                  "decimal": 0
                                },
                                {
                                  "enName": "New",
                                  "cnName": "新进用户",
                                  "metricKey": "new",
                                  "type": "int",
                                  "decimal": 0
                                },
                                {
                                  "enName": "D2",
                                  "cnName": "次留",
                                  "metricKey": "d2",
                                  "type": "percent",
                                  "decimal": 2
                                },
                                {
                                  "enName": "D3",
                                  "cnName": "3留",
                                  "metricKey": "d3",
                                  "type": "percent",
                                  "decimal": 2
                                },
                                {
                                  "enName": "D7",
                                  "cnName": "7留",
                                  "metricKey": "d7",
                                  "type": "percent",
                                  "decimal": 2
                                },
                                {
                                  "enName": "TNU",
                                  "cnName": "总注册用户数",
                                  "metricKey": "tru",
                                  "type": "int",
                                  "decimal": 0
                                },
                                {
                                  "enName": "PCU",
                                  "cnName": "最高同时在线",
                                  "metricKey": "pcu",
                                  "type": "int",
                                  "decimal": 0
                                },
                                {
                                  "enName": "ACU",
                                  "cnName": "平均同时在线",
                                  "metricKey": "acu",
                                  "type": "int",
                                  "decimal": 0
                                },
                                {
                                  "enName": "Avg.Playtime(min)",
                                  "cnName": "平均在线时长(分钟)",
                                  "metricKey": "aot",
                                  "type": "decimals",
                                  "decimal": 2
                                },
                                {
                                  "enName": "WD2",
                                  "cnName": "加权次留",
                                  "metricKey": "weighted_d2",
                                  "type": "percent",
                                  "decimal": 2
                                },
                                {
                                  "enName": "WD3",
                                  "cnName": "加权3留",
                                  "metricKey": "weighted_d3",
                                  "type": "percent",
                                  "decimal": 2
                                },
                                {
                                  "enName": "WD7",
                                  "cnName": "加权7留",
                                  "metricKey": "weighted_d7",
                                  "type": "percent",
                                  "decimal": 2
                                }
                              ]
                            }
                          }
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "OverviewMetricsTrendCo",
                          "className": "",
                          "type": "view",
                          "style": {},
                          "props": {
                            "config": {
                              "renderIndex": 1,
                              "isMoblie": true,
                              "api": {
                                "metricsApi": "/api/v1/dashboard/overview_daily/xh/metrics_trend",
                                "dimensionApi": "/api/v1/dashboard/overview_daily/xh/dimension/metrics_trend"
                              },
                              "componentMetrics": [
                                {
                                  "enName": "Revenue($)",
                                  "cnName": "付费金额($)",
                                  "metricKey": "revenue",
                                  "type": "decimals",
                                  "decimal": 2
                                },
                                {
                                  "enName": "ARPPU($)",
                                  "cnName": "付费ARPPU($)",
                                  "metricKey": "arppu",
                                  "type": "decimals",
                                  "decimal": 2
                                },
                                {
                                  "enName": "ARPU($)",
                                  "cnName": "活跃ARPU($)",
                                  "metricKey": "arpu",
                                  "type": "decimals",
                                  "decimal": 2
                                },
                                {
                                  "enName": "Payer",
                                  "cnName": "付费人数",
                                  "metricKey": "payer",
                                  "type": "int",
                                  "decimal": 0
                                },
                                {
                                  "enName": "Payer%",
                                  "cnName": "付费渗透率",
                                  "metricKey": "payer_ratio",
                                  "type": "percent",
                                  "decimal": 2
                                }
                              ]
                            }
                          }
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "name": "OverviewTableCo",
              "className": "",
              "type": "view",
              "style": {
                "marginTop": "20px"
              },
              "props": {
                "config": {
                  "api": {
                    "tableApi": "/api/v1/dashboard/overview_daily/xh/overall_performance",
                    "tableDownloadApi": "/api/v1/dashboard/overview_daily/xh/performance/download"
                  },
                  "tableConfig": {
                    "hideExplain": true
                  },
                  "componentMetrics": [
                    {
                      "metricKey": "total_users",
                      "reqMetricKey": "total_users",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 160,
                      "enWidth": 110,
                      "cnWidth": 130,
                      "enName": "TNU",
                      "cnName": "总注册用户数",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "new_users",
                      "reqMetricKey": "new_users",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 160,
                      "enWidth": 110,
                      "cnWidth": 110,
                      "enName": "New",
                      "cnName": "新进用户",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "active_users",
                      "reqMetricKey": "active_users",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 160,
                      "enWidth": 110,
                      "cnWidth": 110,
                      "enName": "DAU",
                      "cnName": "日活跃",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "pay_amount",
                      "reqMetricKey": "pay_amount",
                      "enPercentWidth": 190,
                      "cnPercentWidth": 190,
                      "enWidth": 155,
                      "cnWidth": 130,
                      "enName": "Revenue($)",
                      "cnName": "付费金额($)",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "d2",
                      "reqMetricKey": "d2",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 70,
                      "cnWidth": 70,
                      "enName": "D2",
                      "cnName": "次留",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 2
                    },
                    {
                      "metricKey": "d3",
                      "reqMetricKey": "d3",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 70,
                      "cnWidth": 70,
                      "enName": "D3",
                      "cnName": "3留",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 2
                    },
                    {
                      "metricKey": "d4",
                      "reqMetricKey": "d4",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 70,
                      "cnWidth": 70,
                      "enName": "D4",
                      "cnName": "4留",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 2
                    },
                    {
                      "metricKey": "d5",
                      "reqMetricKey": "d5",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 70,
                      "cnWidth": 70,
                      "enName": "D5",
                      "cnName": "5留",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 2
                    },
                    {
                      "metricKey": "d6",
                      "reqMetricKey": "d6",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 70,
                      "cnWidth": 70,
                      "enName": "D6",
                      "cnName": "6留",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 2
                    },
                    {
                      "metricKey": "d7",
                      "reqMetricKey": "d7",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 70,
                      "cnWidth": 70,
                      "enName": "D7",
                      "cnName": "7留",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 2
                    },
                    {
                      "metricKey": "d14",
                      "reqMetricKey": "d14",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 70,
                      "cnWidth": 70,
                      "enName": "D14",
                      "cnName": "14留",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 2
                    },
                    {
                      "metricKey": "d30",
                      "reqMetricKey": "d30",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 70,
                      "cnWidth": 70,
                      "enName": "D30",
                      "cnName": "30留",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 2
                    },
                    {
                      "metricKey": "pcu",
                      "reqMetricKey": "pcu",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 160,
                      "enWidth": 85,
                      "cnWidth": 122,
                      "enName": "PCU",
                      "cnName": "最高同时在线",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "acu",
                      "reqMetricKey": "acu",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 160,
                      "enWidth": 85,
                      "cnWidth": 122,
                      "enName": "ACU",
                      "cnName": "平均同时在线",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "aot",
                      "reqMetricKey": "aot",
                      "enPercentWidth": 180,
                      "cnPercentWidth": 180,
                      "enWidth": 166,
                      "cnWidth": 190,
                      "enName": "Avg.Playtime(min)",
                      "cnName": "平均在线时长(分钟)",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "paid_users",
                      "reqMetricKey": "paid_users",
                      "enPercentWidth": 130,
                      "cnPercentWidth": 140,
                      "enWidth": 130,
                      "cnWidth": 140,
                      "enName": "Payer",
                      "cnName": "付费人数",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "payer_rate",
                      "reqMetricKey": "payer_rate",
                      "enPercentWidth": 130,
                      "cnPercentWidth": 130,
                      "enWidth": 130,
                      "cnWidth": 130,
                      "enName": "Payer%",
                      "cnName": "付费渗透率",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "arpu",
                      "reqMetricKey": "arpu",
                      "enPercentWidth": 190,
                      "cnPercentWidth": 190,
                      "enWidth": 115,
                      "cnWidth": 120,
                      "enName": "ARPU($)",
                      "cnName": "活跃ARPU($)",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "arppu",
                      "reqMetricKey": "arppu",
                      "enPercentWidth": 190,
                      "cnPercentWidth": 190,
                      "enWidth": 115,
                      "cnWidth": 150,
                      "enName": "ARPPU($)",
                      "cnName": "付费ARPPU($)",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "new_paid_users",
                      "reqMetricKey": "new_paid_users",
                      "enPercentWidth": 200,
                      "cnPercentWidth": 200,
                      "enWidth": 200,
                      "cnWidth": 140,
                      "enName": "First-time Payer",
                      "cnName": "首次付费用户",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "new_pay_amount",
                      "reqMetricKey": "new_pay_amount",
                      "enPercentWidth": 240,
                      "cnPercentWidth": 190,
                      "enWidth": 240,
                      "cnWidth": 170,
                      "enName": "Revenue(first-time payer)",
                      "cnName": "首次付费用户金额",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "new_arppu",
                      "reqMetricKey": "new_arppu",
                      "enPercentWidth": 250,
                      "cnPercentWidth": 210,
                      "enWidth": 250,
                      "cnWidth": 210,
                      "enName": "First-time Payer ARPPU($)",
                      "cnName": "首次付费用户ARPPU($)",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "alc",
                      "reqMetricKey": "alc",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 125,
                      "enWidth": 160,
                      "cnWidth": 125,
                      "enName": "Sessions per user",
                      "cnName": "平均登录次数",
                      "type": "decimals",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "retention_users",
                      "reqMetricKey": "retention_users",
                      "enPercentWidth": 190,
                      "cnPercentWidth": 120,
                      "enWidth": 190,
                      "cnWidth": 120,
                      "enName": "DAU Retention Users",
                      "cnName": "日活留存",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "churn_users",
                      "reqMetricKey": "churn_users",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 160,
                      "enWidth": 130,
                      "cnWidth": 100,
                      "enName": "Churn Users",
                      "cnName": "日流失",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "churn_rate",
                      "reqMetricKey": "churn_rate",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 80,
                      "cnWidth": 86,
                      "enName": "Churn%",
                      "cnName": "流失率",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "return_users",
                      "reqMetricKey": "return_users",
                      "enPercentWidth": 180,
                      "cnPercentWidth": 170,
                      "enWidth": 160,
                      "cnWidth": 95,
                      "enName": "DAU Return Users",
                      "cnName": "日回流",
                      "type": "int",
                      "decimal": 0,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "weighted_d2",
                      "reqMetricKey": "weighted_d2",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 122,
                      "cnWidth": 80,
                      "enName": "Weighted D2",
                      "cnName": "加权次留",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "weighted_d3",
                      "reqMetricKey": "weighted_d3",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 122,
                      "cnWidth": 80,
                      "enName": "Weighted D3",
                      "cnName": "加权3留",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "weighted_d7",
                      "reqMetricKey": "weighted_d7",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 122,
                      "cnWidth": 80,
                      "enName": "Weighted D7",
                      "cnName": "加权7留",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "weighted_d14",
                      "reqMetricKey": "weighted_d14",
                      "enPercentWidth": 145,
                      "cnPercentWidth": 145,
                      "enWidth": 132,
                      "cnWidth": 90,
                      "enName": "Weighted D14",
                      "cnName": "加权14留",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "first_login_ratio",
                      "reqMetricKey": "first_login_ratio",
                      "enPercentWidth": 160,
                      "cnPercentWidth": 145,
                      "enWidth": 160,
                      "cnWidth": 145,
                      "enName": "1st Order Login%",
                      "cnName": "一阶登录比",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    },
                    {
                      "metricKey": "second_login_ratio",
                      "reqMetricKey": "second_login_ratio",
                      "enPercentWidth": 170,
                      "cnPercentWidth": 145,
                      "enWidth": 170,
                      "cnWidth": 145,
                      "enName": "2nd Order Login%",
                      "cnName": "二阶登录比",
                      "type": "percent",
                      "decimal": 2,
                      "percentDecimals": 1
                    }
                  ]
                }
              }
            },
            {
              "name": "CommonRow",
              "className": "margin-t-10",
              "type": "layout",
              "style": {},
              "props": {},
              "children": [
                {
                  "name": "UserCompositionCo",
                  "className": "",
                  "type": "view",
                  "props": {
                    "config": {
                      "api": "/api/v1/dashboard/overview_daily/xh/metrics_users",
                      "byType": "country"
                    }
                  },
                  "children": [
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "MetricsUserCompositionCo",
                          "className": "",
                          "type": "view",
                          "style": {},
                          "props": {
                            "config": {
                              "timeType": "DAY",
                              "metricType": "dau",
                              "jumpUrl": "/engagement/active/activeUsers",
                              "initChartIndex": 0,
                              "tooltipConfig": {
                                "valueNameEn": "DAU",
                                "valueNameCn": "日活跃",
                              },
                              "showComList": [
                                "barChart",
                                "lineChart",
                                "sheet"
                              ]
                            }
                          }
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "MetricsUserCompositionCo",
                          "className": "",
                          "type": "view",
                          "style": {},
                          "props": {
                            "config": {
                              "timeType": "DAY",
                              "metricType": "channel",
                              "titleEn": "Channels of New Users",
                              "titleCn": "新进用户渠道构成",
                              "jumpUrl": "/engagement/register",
                              "metricKey": "channels_of_new_user_v2",
                              "metricTotalKey": "channels_of_new_user_total",
                              "accumateKey": "channel",
                              "initChartIndex": 0,
                              "tooltipConfig": {
                                "valueNameEn": "New Users",
                                "valueNameCn": "新进用户",
                              },
                              "showComList": [
                                "barChart",
                                "lineChart",
                                "sheet"
                              ]
                            }
                          }
                        }
                      ]
                    }
                  ]
                }
              ]
            },
            {
              "name": "CommonRow",
              "className": "",
              "type": "layout",
              "style": {},
              "props": {},
              "children": [
                {
                  "name": "RankListTabCo",
                  "className": "",
                  "style": {},
                  "type": "view",
                  "data": {
                    "regionDataType": "country",
                    "tabOrder": [
                      "country",
                      "region",
                      "zone",
                      "channel",
                      "os"
                    ]
                  },
                  "children": [
                    {
                      "name": "CommonMobileDailyRankServiceCo",
                      "className": "",
                      "style": {},
                      "type": "view",
                      "props": {
                        "config": {
                          "api": "/api/v1/dashboard/overview_daily/xh/countries_region_zone"
                        }
                      },
                      "children": [
                        {
                          "name": "CommonMobileDailyRankListCo",
                          "className": "",
                          "type": "view",
                          "style": {},
                          "props": {
                            "config": {
                              "metric": "dau",
                              "componentMetrics": {
                                "reqMetricKey": "active",
                                "metricKey": "value",
                                "enTitleName": "DAU",
                                "cnTitleName": "日活跃",
                                "enName": "DAU",
                                "cnName": "日活跃用户",
                                "enWeekName": "WAU",
                                "cnWeekName": "周活跃用户",
                                "enMonthName": "MAU",
                                "cnMonthName": "月活跃用户",
                                "rangeEnName": "Avg.DAU",
                                "rangeCnName": "日平均活跃",
                                "rangeEnWeekName": "Avg.WAU",
                                "rangeCnWeekName": "周平均活跃",
                                "rangeEnMonthName": "Avg.MAU",
                                "rangeCnMonthName": "月平均活跃",
                                "prefix": "Avg",
                                "type": "int",
                                "decimal": 0,
                                "percentDecimals": 0,
                                "showConfig": {
                                  "showTable": true,
                                  "showChart": true
                                }
                              },
                              "jumpUrl": "/comparisonAnalysis/countryComparison",
                              "initChartIndex": 3,
                              "isShowMapByCountry": true,
                              "comConfig": {
                                "isHaveBar": true,
                                "isHaveLine": true,
                                "isHavePie": true,
                                "isHaveShare": true
                              }
                            }
                          }
                        },
                        {
                          "name": "CommonMobileDailyRankListCo",
                          "className": "",
                          "type": "view",
                          "style": {},
                          "props": {
                            "config": {
                              "metric": "revenue",
                              "componentMetrics": {
                                "reqMetricKey": "revenue",
                                "metricKey": "value",
                                "enTitleName": "Revenue",
                                "cnTitleName": "付费金额",
                                "enName": "Revenue($)",
                                "cnName": "付费金额",
                                "rangeEnName": "Sum Revenue($)",
                                "rangeCnName": "总付费金额($)",
                                "prefix": "Sum",
                                "type": "decimals",
                                "decimal": 2,
                                "percentDecimals": 1,
                                "showConfig": {
                                  "showTable": true,
                                  "showChart": true
                                }
                              },
                              "jumpUrl": "/comparisonAnalysis/countryComparison",
                              "isShowMapByCountry": true,
                              "initChartIndex": 0,
                              "comConfig": {
                                "isHaveBar": true,
                                "isHaveLine": true,
                                "isHavePie": true,
                                "isHaveShare": true
                              }
                            }
                          }
                        },
                        {
                          "name": "CommonMobileDailyRankListCo",
                          "className": "",
                          "type": "view",
                          "style": {},
                          "props": {
                            "config": {
                              "metric": "new",
                              "componentMetrics": {
                                "reqMetricKey": "new",
                                "metricKey": "value",
                                "enTitleName": "New",
                                "cnTitleName": "新进用户",
                                "enName": "New",
                                "cnName": "新进",
                                "rangeEnName": "Sum New",
                                "rangeCnName": "新进总数",
                                "prefix": "Avg",
                                "type": "int",
                                "decimal": 0,
                                "percentDecimals": 0,
                                "showConfig": {
                                  "showTable": true,
                                  "showChart": true
                                }
                              },
                              "jumpUrl": "/comparisonAnalysis/countryComparison",
                              "initChartIndex": 0,
                              "isShowMapByCountry": true,
                              "comConfig": {
                                "isHaveBar": true,
                                "isHaveLine": true,
                                "isHavePie": true,
                                "isHaveShare": true
                              }
                            }
                          }
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "operationList": [
    {
      "nameEn": "情报",
      "nameCn": "Intelligence",
      "url": "function(data) { const { unifiedid } = data; return '/intelligence/topCharts/mobileGames/gamesDetails/' + unifiedid;  }"
    },
    {
      "nameEn": "舆情",
      "nameCn": "Opinions",
      "url": "/opinion/Overview",
      "params": { "gameid": "unifiedid" },
      "permission": "hasOpinionPermissions"
    },
  ]
};